var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-content"},[_c('div',{staticClass:"empty-grp"},[_vm._m(0),_c('p',{staticClass:"empty-tt",domProps:{"textContent":_vm._s(_vm.txt)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-grp"},[_c('i',{staticClass:"icon icon-empty"})])
}]

export { render, staticRenderFns }